import {
  BudgetModel,
  Option,
  TimeFrame,
} from '../../../../../utils/customTypes';
import { EDIT_BUDGET_TABS, MONTHS } from '../../../../../utils/constants';
import intl from 'react-intl-universal';
interface GeneratePlanTableHeaderDataProps {
  selectedBudget: BudgetModel | undefined;
  selectedBudgetView: Option | undefined;
}

const GeneratePlanTableHeaderData = ({
  selectedBudget,
  selectedBudgetView,
}: GeneratePlanTableHeaderDataProps) => {
  const fiscalPeriodStartMonth = selectedBudget
    ? parseInt(selectedBudget?.fiscalPeriodStart.split('-')[1], 10) - 1
    : 0;
  const timeFrame = selectedBudget?.timeFrame || TimeFrame.QUARTERLY;
  const annualTotalColumn = [];
  if (timeFrame !== TimeFrame.YEARLY) {
    annualTotalColumn.push({
      content: (
        <div className='text-right w-157px p-2'>
          {intl.get('BUDGET_PAGE.EDIT.TABLE.HEAD.ANNUAL')}
        </div>
      ),
      className: 'p-0 text-neutral-dark',
    });
  }
  const headCells = [
    {
      content: (
        <div className='w-200px p-2'>
          {selectedBudgetView?.value === EDIT_BUDGET_TABS.PROGRAM_OR_PROJECT
            ? intl.get('BUDGET_PAGE.EDIT.TABLE.HEAD.PROGRAM')
            : selectedBudgetView?.value === EDIT_BUDGET_TABS.VENDORS
            ? intl.get('BUDGET_PAGE.EDIT.TABLE.HEAD.VENDOR')
            : intl.get('BUDGET_PAGE.EDIT.TABLE.HEAD.TEAM')}
        </div>
      ),
      className: 'p-0 left-0 z-2',
    },
    ...annualTotalColumn,
    ...generateTableHeaderForTimeframes(fiscalPeriodStartMonth, timeFrame),
    selectedBudgetView?.value !== EDIT_BUDGET_TABS.TEAMS
      ? {
          content: intl.get('BUDGET_PAGE.EDIT.TABLE.HEAD.TEAM'),
          className: 'w-157px',
        }
      : null,
    selectedBudgetView?.value !== EDIT_BUDGET_TABS.PROGRAM_OR_PROJECT
      ? {
          content: intl.get('BUDGET_PAGE.EDIT.TABLE.HEAD.PROGRAM'),
          className: 'w-157px',
        }
      : null,
    selectedBudgetView?.value !== EDIT_BUDGET_TABS.PROGRAM_OR_PROJECT
      ? {
          content: intl.get('BUDGET_PAGE.EDIT.TABLE.HEAD.PROJECT'),
          className: 'w-157px',
        }
      : null,
    {
      content: intl.get('BUDGET_PAGE.EDIT.TABLE.HEAD.BUDGET_SOURCE'),
      className: 'w-157px',
    },
    selectedBudgetView?.value !== EDIT_BUDGET_TABS.VENDORS
      ? {
          content: intl.get('BUDGET_PAGE.EDIT.TABLE.HEAD.VENDOR'),
          className: 'w-157px',
        }
      : null,
    {
      content: '',
      className: 'w-120px',
    },
  ].filter(Boolean);

  return { stickyHeader: true, headCells };
};

export default GeneratePlanTableHeaderData;

const generateTableHeaderForTimeframes = (
  fiscalMonthStart: number,
  timeFrame: TimeFrame
): any[] => {
  if (timeFrame === TimeFrame.QUARTERLY) {
    return [
      {
        content: <div className='w-157px p-2'>Q1</div>,
        className: 'p-0 text-right',
      },
      {
        content: <div className='w-157px p-2'>Q2</div>,
        className: 'p-0 text-right',
      },
      {
        content: <div className='w-157px p-2'>Q3</div>,
        className: 'p-0 text-right',
      },
      {
        content: <div className='w-157px p-2'>Q4</div>,
        className: 'p-0 text-right',
      },
    ];
  } else if (timeFrame === TimeFrame.MONTHLY) {
    const rearrangedMonths = [
      ...MONTHS.slice(fiscalMonthStart),
      ...MONTHS.slice(0, fiscalMonthStart),
    ];
    return rearrangedMonths.map((month) => ({
      content: (
        <div className='w-157px'>
          {intl.get(`BUDGET_PAGE.FISCAL_YEAR_OPTIONS.${month}`)}
        </div>
      ),
      className: 'w-157px text-right',
    }));
  } else if (timeFrame === TimeFrame.YEARLY) {
    return [
      {
        content: 'Annual',
        className: 'w-157px text-right',
      },
    ];
  } else {
    return [];
  }
};
